import type React from "react"

const USER_STATUSES = {
  NEW: "new",
  NO_ACCESS: "no access",
  ACTIVE: "active",
  INVITE_SENT: "invite sent",
  SUSPENDED: "suspended"
} as const

type UserStatusesKeys = keyof typeof USER_STATUSES
type UserStatuses = (typeof USER_STATUSES)[UserStatusesKeys]

const USER_STATUSES_OBJ: Record<
  string,
  {
    id: UserStatuses
    value: UserStatuses
    label: string
    style: React.CSSProperties
  }
> = {
  [USER_STATUSES.NEW]: {
    id: USER_STATUSES.NEW,
    value: USER_STATUSES.NEW,
    label: "New",
    style: {
      color: "",
      backgroundColor: "default",
      borderColor: "default"
    }
  },
  [USER_STATUSES.NO_ACCESS]: {
    id: USER_STATUSES.NO_ACCESS,
    value: USER_STATUSES.NO_ACCESS,
    label: "No Access",
    style: {
      color: "",
      backgroundColor: "default",
      borderColor: "default"
    }
  },
  [USER_STATUSES.ACTIVE]: {
    id: USER_STATUSES.ACTIVE,
    value: USER_STATUSES.ACTIVE,
    label: "Active",
    style: {
      color: "#4CAF50",
      backgroundColor: "#E8F2EA",
      borderColor: "#E8F2EA"
    }
  },
  [USER_STATUSES.INVITE_SENT]: {
    id: USER_STATUSES.INVITE_SENT,
    value: USER_STATUSES.INVITE_SENT,
    label: "Invite Sent",
    style: {
      color: "#FF9800",
      backgroundColor: "#FFF5E5",
      borderColor: "#FFF5E5"
    }
  },
  [USER_STATUSES.SUSPENDED]: {
    id: USER_STATUSES.SUSPENDED,
    value: USER_STATUSES.SUSPENDED,
    label: "Suspended",
    style: {
      color: "#E53935",
      backgroundColor: "#F7E7E7",
      borderColor: "#F7E7E7"
    }
  }
}

const USER_STATUSES_MAP = Object.fromEntries(
  Object.values(USER_STATUSES_OBJ).map((item) => [item.label, item])
) as Record<string, (typeof USER_STATUSES_OBJ)[keyof typeof USER_STATUSES_OBJ]>

const USER_DISABLED_STATUSES = [
  USER_STATUSES.ACTIVE,
  USER_STATUSES.SUSPENDED
] as string[]

export {
  USER_STATUSES,
  USER_STATUSES_OBJ,
  USER_STATUSES_MAP,
  USER_DISABLED_STATUSES,
  type UserStatuses
}
